import { render, staticRenderFns } from "./ReviewCreativeModal.vue?vue&type=template&id=748bbe3a&scoped=true&"
import script from "./ReviewCreativeModal.vue?vue&type=script&lang=js&"
export * from "./ReviewCreativeModal.vue?vue&type=script&lang=js&"
import style0 from "./ReviewCreativeModal.vue?vue&type=style&index=0&id=748bbe3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748bbe3a",
  null
  
)

export default component.exports